import { Icon } from "../../../assets/icons/Icon";
import "./FeatureSection.scss";

interface FeatureSectionProps {
  title: string;
  reversed?: boolean;
  icon: React.ComponentProps<typeof Icon>["iconName"];
  text: Array<{ title?: string; description: string }>;
  iconTop?: boolean;
  iconHeight?: string;
}

export const FeatureSection = ({
  title,
  icon,
  reversed = false,
  text,
  iconTop = false,
  iconHeight = "100%",
}: FeatureSectionProps) => {
  return (
    <section
      className={`feature-section ${
        reversed ? "feature-section--reversed" : ""
      }`}
    >
      <div className="feature-section__content">
        <div className="feature-section__textBlock">
          {iconTop && (
            <div className="feature-section__image-container">
              <Icon iconName={icon} width="100%" height={iconHeight} />
            </div>
          )}
          <h2 className="feature-section__title">{title}</h2>
          {text.map((text, index) => {
            return (
              <div key={index} className="feature-section__text">
                {text.title && (
                  <h3 className="feature-section__text-title">{text.title}</h3>
                )}
                <p className="feature-section__text-description">
                  {text.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
      {!iconTop && (
        <div className="feature-section__image-container">
          <Icon iconName={icon} width="100%" height="100%" />
        </div>
      )}
    </section>
  );
};
